<div class="modal-form-input">
  <div class="modal-form-input-title">{{ title }}</div>
  <textarea *ngIf="!isSmall else smallInput" [(ngModel)]="formData[formDataField]" [placeholder]="title" maxlength="250"></textarea>
  <div class="modal-form-hint" [class.hidden]="!(isError)">{{ errorText }}</div>
</div>

<ng-template #smallInput>
  <input [(ngModel)]="formData[formDataField]" [placeholder]="title" maxlength="48">
</ng-template>
